var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMachine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 498,
    height: 498,
    viewBox: "0 0 498 498",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M435.192 418.223H64.7399C64.7399 418.223 52.9771 398.402 44.8199 358.562C36.6626 318.722 75.5365 333.264 85.4766 298.922C95.4167 264.58 52.0508 271.821 55.6663 224.83C59.2818 177.838 118.912 176.942 147.826 183.266C176.74 189.591 173.125 167.908 206.59 131.763C240.056 95.6185 290.623 99.2339 315.921 127.251C341.22 155.269 333.082 184.173 364.725 184.173C396.368 184.173 425.292 190.527 444.216 251.064C463.14 311.601 428.509 339.27 429.136 366.6C429.655 383.951 431.681 401.223 435.192 418.223Z",
    fill: "#FF6239"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M435.192 418.223H64.7399C64.7399 418.223 52.9771 398.402 44.8199 358.562C36.6626 318.722 75.5365 333.264 85.4766 298.922C95.4167 264.58 52.0508 271.821 55.6663 224.83C59.2818 177.838 118.912 176.942 147.826 183.266C176.74 189.591 173.125 167.908 206.59 131.763C240.056 95.6185 290.623 99.2339 315.921 127.251C341.22 155.269 333.082 184.173 364.725 184.173C396.368 184.173 425.292 190.527 444.216 251.064C463.14 311.601 428.509 339.27 429.136 366.6C429.655 383.951 431.681 401.223 435.192 418.223Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M214.55 418.218C205.476 404.404 166.742 346.317 155.408 344.763C144.362 343.249 105.11 401.983 94.4922 418.218H214.55Z",
    fill: "#2E353A",
    stroke: "#2E353A",
    strokeWidth: 0.996,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M264.221 78.8164V212.768",
    stroke: "#2E353A",
    strokeWidth: 2.988,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M280.136 82.4062V212.763",
    stroke: "#2E353A",
    strokeWidth: 2.988,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M297.587 153.746V280.009",
    stroke: "#2E353A",
    strokeWidth: 2.988,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M316.062 82.4062V280.003",
    stroke: "#2E353A",
    strokeWidth: 2.988,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M334.538 82.4062V216.358",
    stroke: "#2E353A",
    strokeWidth: 2.988,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M250.366 96.7695H335.056",
    stroke: "#2E353A",
    strokeWidth: 2.988,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M250.366 126.539H342.207",
    stroke: "#2E353A",
    strokeWidth: 2.988,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M248.832 153.746H350.962",
    stroke: "#2E353A",
    strokeWidth: 2.988,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M247.289 184.031H350.963",
    stroke: "#2E353A",
    strokeWidth: 2.988,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M266.79 216.871H345.315",
    stroke: "#2E353A",
    strokeWidth: 2.988,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M287.317 248.691H338.641",
    stroke: "#2E353A",
    strokeWidth: 2.988,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M152.201 91.5352L170.318 105.718",
    stroke: "#2E353A",
    strokeWidth: 1.992,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M188.436 76.5703L194.74 86.0224",
    stroke: "#2E353A",
    strokeWidth: 1.992,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M220.734 53.7227L226.252 71.0531",
    stroke: "#2E353A",
    strokeWidth: 1.992,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M324.1 276.432H294.22V205.387H253.683V79.5625C236.599 79.7312 219.845 84.2918 205.032 92.8059C190.22 101.32 177.846 113.501 169.102 128.179C160.357 142.857 155.535 159.537 155.099 176.617C154.663 193.696 158.628 210.601 166.613 225.706C169.86 233.265 177.489 251.781 185.128 275.725C192.19 297.826 195.875 320.047 195.875 323.403C195.875 323.732 195.875 324.071 195.875 324.399C195.84 325.398 196.007 326.394 196.365 327.328C196.724 328.261 197.266 329.113 197.96 329.832C198.654 330.551 199.486 331.123 200.406 331.515C201.326 331.906 202.316 332.108 203.315 332.108H306.152C307.152 332.106 308.14 331.903 309.06 331.512C309.979 331.12 310.81 330.548 311.504 329.829C312.198 329.11 312.741 328.259 313.099 327.326C313.458 326.393 313.626 325.398 313.592 324.399C313.592 324.041 313.592 323.702 313.592 323.403C313.573 320.087 317.188 298.294 324.1 276.432Z",
    fill: "#FF6239",
    stroke: "#2E353A",
    strokeWidth: 1.992,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M219.93 95.6186C222.812 94.3191 225.769 93.1917 228.784 92.2422",
    stroke: "#2E353A",
    strokeWidth: 1.992,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M186.761 120.85C186.761 120.85 194.878 107.902 212.717 99.1875",
    stroke: "#2E353A",
    strokeWidth: 1.992,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M188.894 264.199C192.589 276.271 197.479 292.994 199.172 302.336C202.041 318.093 200.168 326.24 206.343 327.644",
    stroke: "#2E353A",
    strokeWidth: 1.992,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M184.371 249.797C184.371 249.797 185.367 253.034 186.971 257.994",
    stroke: "#2E353A",
    strokeWidth: 1.992,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M248.423 331.141V235.923C248.423 235.923 252.407 211.023 239.459 211.023C226.511 211.023 227.507 223.971 242.447 237.915C257.387 251.859 280.295 238.911 283.283 227.955C286.271 216.999 278.303 212.019 273.323 220.983C268.343 229.947 273.323 331.539 273.323 331.539",
    stroke: "#2E353A",
    strokeWidth: 1.992,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M308.751 331.527H201.272V356.467H308.751V331.527Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 1.992,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M308.751 362.406H201.272V387.346H308.751V362.406Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 1.992,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M308.751 356.469H201.272V362.405H308.751V356.469Z",
    fill: "#2E353A",
    stroke: "#2E353A",
    strokeWidth: 0.996,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M308.751 393.281H201.272V418.221H308.751V393.281Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 1.992,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M297.507 353.129H305.495",
    stroke: "#2E353A",
    strokeWidth: 0.996,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M205.497 353.129H293.663",
    stroke: "#2E353A",
    strokeWidth: 0.996,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M276.791 384.492H302.538",
    stroke: "#2E353A",
    strokeWidth: 0.996,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M221.452 384.492H273.832",
    stroke: "#2E353A",
    strokeWidth: 0.996,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M212.877 384.492H217.309",
    stroke: "#2E353A",
    strokeWidth: 0.996,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M308.751 387.344H201.272V393.28H308.751V387.344Z",
    fill: "#2E353A",
    stroke: "#2E353A",
    strokeWidth: 0.996,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M252.059 398.746H215.267V417.899H252.059V398.746Z",
    fill: "#FF6239",
    stroke: "#2E353A",
    strokeWidth: 0.996,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M299.937 398.746H263.145V417.899H299.937V398.746Z",
    fill: "#FF6239",
    stroke: "#2E353A",
    strokeWidth: 0.996,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M333.031 418.221C325.98 412.036 295.871 386.03 287.106 385.353C278.52 384.666 248.043 410.97 239.796 418.221H333.031Z",
    fill: "#2E353A",
    stroke: "#2E353A",
    strokeWidth: 0.996,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M449.276 418.219H457.922",
    stroke: "#2E353A",
    strokeWidth: 0.996,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5254 418.219H440.631",
    stroke: "#2E353A",
    strokeWidth: 0.996,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0791 418.219H46.8021",
    stroke: "#2E353A",
    strokeWidth: 0.996,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M431.875 361.383H406.029V397.637H416.736H431.875H442.592V379.51L431.875 361.383Z",
    fill: "#2E353A",
    stroke: "#2E353A",
    strokeWidth: 0.996,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M442.592 397.633H430.75V405.87H442.592V397.633Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.996,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M386.815 397.227C386.815 397.227 399.763 390.255 395.281 355.395L378.847 346.431L350.461 341.949L325.063 342.945V357.387C325.063 357.387 339.505 369.837 340.999 373.821C341.936 376.548 342.441 379.405 342.493 382.287V396.231L386.815 397.227Z",
    fill: "#FF6239",
    stroke: "#2E353A",
    strokeWidth: 0.996,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M395.281 355.395L386.815 397.227",
    stroke: "#2E353A",
    strokeWidth: 0.996,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M378.848 346.43L369.386 397.226",
    stroke: "#2E353A",
    strokeWidth: 0.996,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M350.462 341.949L343.49 379.797",
    stroke: "#2E353A",
    strokeWidth: 0.996,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M326.06 355.395C326.06 355.395 342.494 362.367 348.968 366.849C355.442 371.331 354.446 380.793 354.446 380.793",
    stroke: "#2E353A",
    strokeWidth: 0.996,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M406.258 397.898H329.038V404.372H406.258V397.898Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.996,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M421.676 381.292H437.801L429.146 366.352H421.676V381.292Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.996,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M419.186 366.352H412.214V381.292H419.186V366.352Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.996,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M376.458 397.633H329.447V408.858H376.458V397.633Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.996,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M420.992 418.039C426.368 417.068 429.938 411.924 428.967 406.548C427.996 401.173 422.851 397.603 417.476 398.574C412.101 399.545 408.53 404.69 409.501 410.065C410.472 415.44 415.617 419.01 420.992 418.039Z",
    fill: "#2E353A",
    stroke: "#2E353A",
    strokeWidth: 0.996,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M419.215 414.108C422.4 414.108 424.982 411.526 424.982 408.341C424.982 405.156 422.4 402.574 419.215 402.574C416.03 402.574 413.448 405.156 413.448 408.341C413.448 411.526 416.03 414.108 419.215 414.108Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.996,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M344.765 418.062C350.144 417.11 353.732 411.978 352.78 406.599C351.828 401.22 346.696 397.632 341.317 398.584C335.938 399.537 332.35 404.669 333.302 410.047C334.255 415.426 339.387 419.014 344.765 418.062Z",
    fill: "#2E353A",
    stroke: "#2E353A",
    strokeWidth: 0.996,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M343.022 414.108C346.207 414.108 348.789 411.526 348.789 408.341C348.789 405.156 346.207 402.574 343.022 402.574C339.837 402.574 337.255 405.156 337.255 408.341C337.255 411.526 339.837 414.108 343.022 414.108Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.996,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M373.59 415.583C377.614 411.889 377.88 405.633 374.186 401.609C370.491 397.586 364.235 397.319 360.212 401.014C356.188 404.708 355.922 410.965 359.616 414.988C363.311 419.011 369.567 419.278 373.59 415.583Z",
    fill: "#2E353A",
    stroke: "#2E353A",
    strokeWidth: 0.996,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M366.896 414.108C370.081 414.108 372.663 411.526 372.663 408.341C372.663 405.156 370.081 402.574 366.896 402.574C363.711 402.574 361.129 405.156 361.129 408.341C361.129 411.526 363.711 414.108 366.896 414.108Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.996,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M363.659 380.293H338.759C336.972 380.293 335.522 381.742 335.522 383.53V393.988C335.522 395.776 336.972 397.225 338.759 397.225H363.659C365.447 397.225 366.896 395.776 366.896 393.988V383.53C366.896 381.742 365.447 380.293 363.659 380.293Z",
    fill: "#2E353A",
    stroke: "#2E353A",
    strokeWidth: 0.996,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M323.071 397.225V347.973H333.031V397.225",
    stroke: "#2E353A",
    strokeWidth: 0.996,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M323.142 354.5H332.922",
    stroke: "#2E353A",
    strokeWidth: 0.996,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M323.142 362.188H332.922",
    stroke: "#2E353A",
    strokeWidth: 0.996,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M323.142 369.875H332.922",
    stroke: "#2E353A",
    strokeWidth: 0.996,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M323.142 377.578H332.922",
    stroke: "#2E353A",
    strokeWidth: 0.996,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M323.142 385.27H332.922",
    stroke: "#2E353A",
    strokeWidth: 0.996,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M323.142 392.957H332.922",
    stroke: "#2E353A",
    strokeWidth: 0.996,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M123.862 419.189H105.934V106.445L123.862 127.292V419.189Z",
    stroke: "#2E353A",
    strokeWidth: 0.996,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M106.113 353.451H123.693L106.113 336.449H123.693L106.113 353.451Z",
    stroke: "#2E353A",
    strokeWidth: 0.996,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M106.113 336.021H123.693L106.113 319.02H123.693L106.113 336.021Z",
    stroke: "#2E353A",
    strokeWidth: 0.996,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M106.113 318.595H123.693L106.113 301.594H123.693L106.113 318.595Z",
    stroke: "#2E353A",
    strokeWidth: 0.996,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M106.113 301.166H123.693L106.113 284.164H123.693L106.113 301.166Z",
    stroke: "#2E353A",
    strokeWidth: 0.996,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M106.113 283.736H123.693L106.113 266.734H123.693L106.113 283.736Z",
    stroke: "#2E353A",
    strokeWidth: 0.996,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M106.113 266.306H123.693L106.113 249.305H123.693L106.113 266.306Z",
    stroke: "#2E353A",
    strokeWidth: 0.996,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M106.113 248.873H123.693L106.113 231.871H123.693L106.113 248.873Z",
    stroke: "#2E353A",
    strokeWidth: 0.996,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M106.113 231.443H123.693L106.113 214.441H123.693L106.113 231.443Z",
    stroke: "#2E353A",
    strokeWidth: 0.996,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M106.113 214.013H123.693L106.113 197.012H123.693L106.113 214.013Z",
    stroke: "#2E353A",
    strokeWidth: 0.996,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M106.113 196.584H123.693L106.113 179.582H123.693L106.113 196.584Z",
    stroke: "#2E353A",
    strokeWidth: 0.996,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M106.113 179.154H123.693L106.113 162.152H123.693L106.113 179.154Z",
    stroke: "#2E353A",
    strokeWidth: 0.996,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M106.113 161.724H123.693L106.113 144.723H123.693L106.113 161.724Z",
    stroke: "#2E353A",
    strokeWidth: 0.996,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M106.113 144.295H123.693L106.113 127.293H123.693L106.113 144.295Z",
    stroke: "#2E353A",
    strokeWidth: 0.996,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M207.097 144.765L198.412 139.297H136.431L128.861 144.765H207.097Z",
    stroke: "#2E353A",
    strokeWidth: 0.996,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M208.532 144.297H57.1396V148.281H208.532V144.297Z",
    fill: "#2E353A",
    stroke: "#2E353A",
    strokeWidth: 0.996,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M198.412 139.293L105.934 106.445L136.431 139.293",
    stroke: "#2E353A",
    strokeWidth: 0.996,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M105.944 106.445L57.1396 144.293",
    stroke: "#2E353A",
    strokeWidth: 0.996,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M136.82 152.758H99.4697V176.662H136.82V152.758Z",
    fill: "#2E353A",
    stroke: "#2E353A",
    strokeWidth: 0.996,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M129.03 157.742H107.247V164.714H129.03V157.742Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.996,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M208.531 148.277V191.225",
    stroke: "#2E353A",
    strokeWidth: 0.996,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M214.208 205.898H203.143V218.438H214.208V205.898Z",
    fill: "#2E353A",
    stroke: "#2E353A",
    strokeWidth: 0.996,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M203.143 205.894L208.68 190.406L214.218 205.894",
    stroke: "#2E353A",
    strokeWidth: 0.996,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M178.681 357.221L202.585 395.009L208.561 390.637L190.972 355.458C190.181 353.877 188.966 352.547 187.462 351.618C185.957 350.689 184.224 350.198 182.456 350.199C181.645 350.214 180.852 350.445 180.159 350.868C179.466 351.291 178.898 351.89 178.514 352.605C178.129 353.32 177.942 354.125 177.972 354.936C178.001 355.747 178.246 356.536 178.681 357.221Z",
    fill: "#FF6239",
    stroke: "#2E353A",
    strokeWidth: 0.996,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M206.46 385.719L181.869 403.209C181.869 403.209 184.06 412.491 198.263 411.943C212.466 411.396 211.928 396.645 211.928 396.645L206.46 385.719Z",
    fill: "#2E353A",
    stroke: "white",
    strokeWidth: 0.996,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M138.153 374.241L182.694 354.172C184.163 353.511 185.814 353.373 187.373 353.78C188.931 354.188 190.303 355.117 191.26 356.413C191.819 357.169 192.221 358.03 192.442 358.945C192.663 359.86 192.698 360.809 192.546 361.738C192.394 362.666 192.057 363.555 191.555 364.351C191.054 365.147 190.398 365.834 189.627 366.373L140.892 400.486L138.153 374.241Z",
    fill: "#FF6239",
    stroke: "#2E353A",
    strokeWidth: 0.996,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M131.601 398.832H85.6953V405.934H131.601V398.832Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.996,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M109.191 378.609H69.3008V395.004H109.191V378.609Z",
    fill: "#2E353A",
    stroke: "#2E353A",
    strokeWidth: 0.996,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M104.002 360.031H137.866C138.658 360.031 139.418 360.346 139.979 360.906C140.539 361.467 140.854 362.227 140.854 363.019V394.991H101.004V363.019C101.004 362.626 101.082 362.237 101.232 361.874C101.383 361.51 101.604 361.18 101.883 360.903C102.161 360.625 102.492 360.405 102.855 360.256C103.219 360.106 103.609 360.03 104.002 360.031Z",
    fill: "#FF6239",
    stroke: "#2E353A",
    strokeWidth: 0.996,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M68.893 418.22H134.201C136.264 418.22 138.242 417.4 139.701 415.942C141.16 414.483 141.979 412.504 141.979 410.441C141.979 408.377 141.16 406.398 139.702 404.937C138.243 403.477 136.265 402.655 134.201 402.652H68.893C66.829 402.655 64.8505 403.477 63.392 404.937C61.9335 406.398 61.1143 408.377 61.1143 410.441C61.1143 412.504 61.9338 414.483 63.3926 415.942C64.8514 417.4 66.83 418.22 68.893 418.22Z",
    fill: "#2E353A",
    stroke: "#2E353A",
    strokeWidth: 0.996,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M78.7331 418.22H144.031C146.095 418.22 148.074 417.401 149.535 415.942C150.995 414.484 151.817 412.505 151.82 410.441C151.82 408.375 150.999 406.394 149.538 404.934C148.078 403.473 146.097 402.652 144.031 402.652H78.7331C76.6674 402.652 74.6863 403.473 73.2256 404.934C71.7649 406.394 70.9443 408.375 70.9443 410.441C70.947 412.505 71.7687 414.484 73.2291 415.942C74.6895 417.401 76.6691 418.22 78.7331 418.22Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.996,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M140.883 395.008H69.3008V400.476H140.883V395.008Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.996,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M84.0622 410.448C84.0622 411.421 83.7736 412.372 83.233 413.181C82.6923 413.99 81.9239 414.621 81.0248 414.993C80.1258 415.366 79.1365 415.463 78.182 415.273C77.2276 415.083 76.3509 414.615 75.6628 413.927C74.9747 413.239 74.5061 412.362 74.3162 411.407C74.1264 410.453 74.2238 409.464 74.5962 408.565C74.9686 407.666 75.5993 406.897 76.4084 406.357C77.2175 405.816 78.1688 405.527 79.1419 405.527C80.4468 405.527 81.6983 406.046 82.6211 406.968C83.5438 407.891 84.0622 409.143 84.0622 410.448Z",
    fill: "#2E353A",
    stroke: "#2E353A",
    strokeWidth: 0.996,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M92.2581 415.368C94.9755 415.368 97.1784 413.165 97.1784 410.448C97.1784 407.73 94.9755 405.527 92.2581 405.527C89.5408 405.527 87.3379 407.73 87.3379 410.448C87.3379 413.165 89.5408 415.368 92.2581 415.368Z",
    fill: "#2E353A",
    stroke: "#2E353A",
    strokeWidth: 0.996,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M105.367 415.368C108.084 415.368 110.287 413.165 110.287 410.448C110.287 407.73 108.084 405.527 105.367 405.527C102.649 405.527 100.446 407.73 100.446 410.448C100.446 413.165 102.649 415.368 105.367 415.368Z",
    fill: "#2E353A",
    stroke: "#2E353A",
    strokeWidth: 0.996,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M123.404 410.448C123.404 411.421 123.115 412.372 122.575 413.181C122.034 413.99 121.266 414.621 120.367 414.993C119.468 415.366 118.478 415.463 117.524 415.273C116.569 415.083 115.693 414.615 115.005 413.927C114.316 413.239 113.848 412.362 113.658 411.407C113.468 410.453 113.566 409.464 113.938 408.565C114.31 407.666 114.941 406.897 115.75 406.357C116.559 405.816 117.511 405.527 118.484 405.527C119.789 405.527 121.04 406.046 121.963 406.968C122.886 407.891 123.404 409.143 123.404 410.448Z",
    fill: "#2E353A",
    stroke: "#2E353A",
    strokeWidth: 0.996,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M136.521 410.448C136.521 411.421 136.233 412.372 135.692 413.181C135.151 413.99 134.383 414.621 133.484 414.993C132.585 415.366 131.595 415.463 130.641 415.273C129.687 415.083 128.81 414.615 128.122 413.927C127.434 413.239 126.965 412.362 126.775 411.407C126.585 410.453 126.683 409.464 127.055 408.565C127.428 407.666 128.058 406.897 128.867 406.357C129.676 405.816 130.628 405.527 131.601 405.527C132.906 405.527 134.157 406.046 135.08 406.968C136.003 407.891 136.521 409.143 136.521 410.448Z",
    fill: "#2E353A",
    stroke: "#2E353A",
    strokeWidth: 0.996,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M149.63 410.448C149.63 411.421 149.341 412.373 148.8 413.182C148.259 413.992 147.49 414.622 146.59 414.994C145.69 415.366 144.7 415.463 143.746 415.273C142.791 415.082 141.914 414.612 141.227 413.923C140.539 413.234 140.071 412.356 139.882 411.401C139.694 410.446 139.793 409.457 140.166 408.558C140.54 407.659 141.173 406.891 141.983 406.352C142.793 405.812 143.746 405.525 144.719 405.527C145.365 405.527 146.004 405.655 146.601 405.902C147.197 406.149 147.739 406.512 148.195 406.969C148.651 407.426 149.012 407.969 149.259 408.565C149.505 409.162 149.631 409.802 149.63 410.448Z",
    fill: "#2E353A",
    stroke: "#2E353A",
    strokeWidth: 0.996,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M187.884 360.028C187.884 359.486 187.723 358.956 187.422 358.505C187.121 358.055 186.692 357.704 186.191 357.497C185.69 357.29 185.139 357.236 184.607 357.342C184.076 357.449 183.588 357.711 183.205 358.095C182.822 358.479 182.562 358.968 182.458 359.5C182.353 360.032 182.409 360.583 182.618 361.083C182.826 361.583 183.179 362.011 183.631 362.31C184.083 362.61 184.613 362.769 185.155 362.767C185.514 362.767 185.87 362.696 186.202 362.558C186.534 362.421 186.835 362.219 187.088 361.964C187.342 361.71 187.543 361.408 187.679 361.075C187.816 360.743 187.886 360.387 187.884 360.028Z",
    fill: "#2E353A",
    stroke: "#2E353A",
    strokeWidth: 0.996,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M134.878 364.398H105.914V381.888H134.878V364.398Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.996,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M134.878 364.398H119.031V381.888H134.878V364.398Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.996,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMachine);
export default __webpack_public_path__ + "static/media/machine.a014ad8487dfa432b47ba16816167d51.svg";
export { ForwardRef as ReactComponent };